import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, IconButton } from "@mui/material";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDeleteDealsMutation } from "store/slices/apis/dealApiSlice";
import { MdDeleteOutline } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import CustomButton from "components/Button";

const DeleteLeads = (props) => {
    const dispatch = useDispatch();
    const { open, handleClose, rowData } = props;
    const [deleteDeals, { isLoading }] = useDeleteDealsMutation();

    const handleSubmit = async () => {
        try {
            await deleteDeals(rowData?.dealId).unwrap();
            openNotification("Deal deleted successfully!", "success");
            handleClose();
        } catch (error) {
            openNotification("Failed to delete Deal!", "error");
            //console.error(error);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <>
            {/* ---------- Popup Dialog ---------- */}
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #ddd",
                        backgroundColor: "#ECECEC",
                        pb: 2,
                        pt: 3,
                        width: "100%",
                    }}
                >

                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Delete Deal
                    </Typography>

                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>

                </DialogTitle>
                <DialogContent sx={{ padding: '24px !important' }}>
                    <DialogContentText sx={{ fontWeight: 400, fontSize: '16px', color: '#474747', fontFamily: "Outfit, sans-serif" }}>
                        Are you sure you want to Delete this Deal ? This action is permanent.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <CustomButton
                        label="Delete"
                        startIcon={<MdDeleteOutline />}
                        onClick={handleSubmit}
                        sx={{
                            backgroundColor: "#00344C",
                            fontFamily: 'Outfit',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '100%',
                            letterSpacing: '0px',
                        }}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteLeads;